module.exports = __webpack_public_path__ + "img/pm_active.36f64574.svg";